module.exports = __webpack_public_path__ + "assets/img/star_sentence_select7.7681d677.png";